import React from 'react';
import { Link } from 'react-router-dom';
import css from 'styled-jsx/css';
import cn from 'classnames';
import { breakpoints, colors } from '../config';

const { className, styles } = css.resolve`
  .btn {
    border-radius: ${colors.borderRadius};
    background-color: ${colors.orange};
    color: ${colors.white};
    font-weight: bold;
    text-decoration: none;
    line-height: 1;
    font-size: 19px;
    text-align: center;
    font-family: inherit;
    padding: 18px 32px;
    display: inline-block;
    transition: background-color 0.3s ease-in, transform 0.1s ease;
    border: 0;
    cursor: pointer;
  }

  .btn:hover {
    background-color: ${colors.darkOrange};
  }

  .btn:active {
    transform: scale(0.975);
  }

  @media screen and (max-width: ${breakpoints.md}) {
    .btn-block {
      display: block;
      width: 100%;
    }
  }

  .btn-disabled {
    pointer-events: none;
  }

  .btn-disabled,
  .btn-disabled:hover {
    background-color: ${colors.inputBorderColor};
    color: ${colors.textMuted};
  }

  .btn-secondary {
    border: 1px solid #106eb0;
    color: #106eb0;
    background-color: #fff;
  }

  .btn-secondary:hover {
    background-color: #106eb0;
    color: #fff;
  }
`;

const Button = ({ href, children, block, disabled, external, secondary, onClick, ...rest }) => {
  if (external) {
    return (
      <a
        href={href}
        className={cn('btn', className, {
          'btn-block': block,
          'btn-disabled': disabled,
          'btn-secondary': secondary,
        })}
        target="_blank"
        rel="noopener noreferrer"
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <>
      {href ? (
        <Link
          to={href}
          className={cn('btn', className, { 'btn-block': block, 'btn-disabled': disabled })}
          {...rest}
        >
          {children}
        </Link>
      ) : (
        <button
          onClick={onClick}
          className={cn('btn', className, { 'btn-block': block, 'btn-disabled': disabled })}
          disabled={disabled}
          {...rest}
        >
          {children}
        </button>
      )}

      {styles}
    </>
  );
};

export default Button;
